import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectShare } from './share.actions';
import { turnOffFullscreen } from '../visual/visual.actions';
import { IAppState } from '../app.state';

import {Observable} from 'rxjs/Rx';

@Component({
  selector: 'nns-share',
  styles: [`
    :host {
      -ms-flex:1;
      box-sizing: border-box;
      display: flex;
      flex: 1 1 0;
      -ms-flex-direction: column;
      flex-direction: column;
    }
    `],
  template: `
    <router-outlet></router-outlet>
  `,
})
export class ShareComponent implements OnInit {

  constructor(
    public _route: ActivatedRoute,
    public _store: Store<IAppState>
  ) {
  }

  ngOnInit() {
    this._route.params.forEach((params: Params) => {
       const shareId = params.shareId;
       const securityKey = params.securityKey;

       this._store.dispatch(turnOffFullscreen());
       this._store.dispatch(selectShare(shareId, securityKey));
     });
  }
}
